module.exports = __webpack_public_path__ + "static/media/Whatsapp.924adc27.png";